/* eslint-disable import/prefer-default-export */
import * as Redux from 'redux'
import { reducer as SummaryReducer } from './summary'
import { reducer as DetailsReducer } from './details'

export const reducer = Redux.combineReducers({
  summary: SummaryReducer,
  details: DetailsReducer
})
